
export default function flexibleContent () {

	const buttons = document.querySelectorAll('section.flexible-content .accordion button');

	if (! buttons.length) return;



	// accordion
	buttons.forEach(btn => {

		btn.addEventListener('click', () => {
			const item = btn.closest('.item');
			const answer = item.querySelector('.answer');

			if (item.classList.contains('open')) {
				answer.style.maxHeight = '0';
				item.classList.remove('open');
				btn.setAttribute('aria-expanded', 'false');
			} else {
				answer.style.maxHeight = answer.scrollHeight + 'px';
				item.classList.add('open');
				btn.setAttribute('aria-expanded', 'true');
			}
		});

	});

}
